import React, { Component } from "react";

import Base from "../../../components/Base";
import { Row, Col, Button, Modal } from "antd";

import api from "../../../services/api";
import handleError from "../../../services/apiErrorHandler";

import "../styles.css";

export default class Devolucoes extends Component {
  state = {
    relatorio_loading: false,
    register_loading: false
  };

  handleRegisterDevolucoes = async () => {
    /** Executa as devoluções */
    const file = document.getElementById("planilha_dev").files[0];

    if (file == null) {
      Modal.error({
        title: "Erro",
        content: "Selecione o arquivo para executar as devoluções."
      });
      return;
    }

    this.setState({
      register_loading: true
    });

    let formData = new FormData();

    formData.append("planilha", file);
    formData.append("type", "DEVOLUCAO");

    /** Send post request */
    await api
      .post("/crawlers/devolucoes/", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        Modal.success({
          title: "Atividade solicitada",
          content: (
            <div>
              Atividade solicitada com sucesso! Clique&nbsp;
              <a href="/atividades">aqui</a> para ver suas atividades.
            </div>
          )
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      register_loading: false
    });
  };

  handleRelatorioDevolucao = async () => {
    /** Extrai o relatório de devoluções */
    const data_inicial = document.getElementById("data_inicial").value;
    const data_final = document.getElementById("data_final").value;

    if (data_inicial == null || data_inicial == "") {
      Modal.error({
        title: "Erro",
        content: "Informe a data inicial!"
      });
      return;
    }

    if (data_final == null || data_final == "") {
      Modal.error({
        title: "Erro",
        content: "Informe a data final!"
      });
      return;
    }

    this.setState({
      relatorio_loading: true
    });

    await api
      .post("/crawlers/devolucoes/", {
        type: "RELATORIO",
        data_fim: data_final,
        data_inicio: data_inicial
      })
      .then(() => {
        Modal.success({
          title: "Atividade solicitada",
          content: (
            <div>
              Atividade solicitada com sucesso! Clique&nbsp;
              <a href="/atividades">aqui</a> para ver suas atividades.
            </div>
          )
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      relatorio_loading: false
    });
  };

  render() {
    return (
      <Base title="Devoluções">
        <Row gutter={8}>
          <Col md={{ span: 12 }}>
            <div className="cw__container">
              <div className="cw__title">Relatório de devoluções</div>
              <p>
                * Extrai uma planilha de negócios perdidos do Pipedrive e do
                filtro.
              </p>
              <div className="cw__inputs">
                <input type="date" id="data_inicial" className="ant-input" />
                <div>até</div>
                <input type="date" id="data_final" className="ant-input" />
              </div>
              <div style={{ margin: "10px" }}>
                <Button
                  htmlType="submit"
                  onClick={this.handleRelatorioDevolucao}
                  type="primary"
                  loading={this.state.relatorio_loading}
                >
                  Extrair
                </Button>
              </div>
            </div>
          </Col>
          <Col md={{ span: 12 }}>
            <div className="cw__container">
              <div className="cw__title">Registrar devoluções</div>
              <p>
                * Devolve as pastas na HDI de acordo com a planilha de entrada.
              </p>
              <div className="cw__inputs">
                <input
                  type="file"
                  id="planilha_dev"
                  placeholder="Selecione a planilha de devoluções"
                />
              </div>
              <div style={{ margin: "10px" }}>
                <Button
                  htmlType="submit"
                  onClick={this.handleRegisterDevolucoes}
                  type="primary"
                >
                  Executar
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Crawlers/Devolucoes/index.js